import request from "@/request"

/**
 * 获取分类列表
 */
export function getAllCategorys() {
    return request({
        url: "/categorys",
        method: 'GET',
    })
}

/**
 * 获取分类列表详情（报错每个分类描述和每个分类对应文章数量）
 */
export function listCategoriesDetail() {
    return request({
        url: "/categorys/detail",
        method: 'GET',
    })
}


/**
 * 通过分类id获取分类详情
 */
export function getCategoryDetailById(id) {
    return request({
        url: `/categorys/detail/${id}`,
        method: "GET"
    })
}

